import Notification from "../notification/Notification";
import Database from "../database/Database";
import Sweetalert from "../../components/sweetalert/Sweetalert";

const Auth = {
  setUser(user, setUser) {
    setUser(user);

    Database.set("user", JSON.stringify(user));
  },
  update(user, newData, setData) {
    var newUser = Object.assign({}, user);

    var newUserData = {
      ...newUser,
      ...newData,
    };

    setData(newUserData);

    Database.set("user", JSON.stringify(newUserData));
  },
  getUser() {
    if (Database.get("user")) {
      return JSON.parse(Database.get("user"));
    } else {
      return false;
    }
  },
  chnage(user, newData, setData) {
    var newUser = Object.assign({}, user);

    var newUserData = {
      ...newUser,
      data: {
        ...newUser?.data,
        ...newData,
      },
    };

    setData(newUserData);

    Database.set("user", JSON.stringify(newUserData));
  },
  logout(setData) {
    var data = {
      title: "",
      text: "آیا مطمئن هستید که می خواهید خارج شوید؟",
      icon: "warning",
      confirmButtonText: "بله، خارج می شوم!",
      cancelButtonText: "خیر",
      confirmed: false,
      confirmedCallBack: this.onLogout.bind(this),
    };

    Sweetalert.confirm(data, setData);
  },
  onLogout(setData, notification = true) {
    if (notification) {
      Notification.success("شما با موفقیت خارج شدید.");
    }

    setData(false);

    Database.set("user", false);
  },
};

export default Auth;
